
// INDEXED DB CONFIG //
export const indexedDBs = {
    main: {
        dbName: 'PLLWebDB',
        storeName: 'cache',
        dbVersion: 2
    }
}